let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dXz7U")).then(() => parcelRequire('efF3A'));